$(document).ready(function() {
  
  thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
  	  
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;          
      
      if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
            optionValue = variantImages[strNewImage]['option-'+i];
            $('.single-option-selector option').removeAttr( 'selected' );
            
            $('.single-option-selector option').each( function(){
              var devVal = $(this).val();
              if( devVal.indexOf(optionValue) > -1  ){
                $(this).attr('selected', 'selected');
                $(this).parent('select').val(optionValue).trigger('change');
              }
            });
			            
            //if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
              //$('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
            //}

          });
      }
      
    });
  }
  
  
  //Form must be filled.
  
  jQuery("form[action='/cart/add'] [type=submit]").on("click", function(e) {
    
    var valid = false;
    
    if( $('.single-option-selector').length > 0 ){
    $('.single-option-selector').each( function(){
      if( $(this).val().indexOf('Choose a') > -1 ){
        if( $(this).parent().parent().find('.bold_error_message').text().length <= 0  ){
        	$(this).parent('.form-field-select-wrapper').after('<span class="bold_error_message"><small>This option is required.</small></span>');
        	valid = false;
        }
      } else {
        $(this).parent('.form-field-select-wrapper').siblings('.bold_error_message').remove();
        valid = true;
      }      
    });
    return valid;
    } else {
      return true;
    }
  });
  
  //On colors dropdown change    
  $('.single-option-selector').on('change', function(){
    var checkColorDropdownz1 = true;
  	var checkBoldDropdownz1 = true;
    
    $('.single-option-selector').each( function(){
      if( $(this).val().indexOf('Choose a') > -1 ){
        checkColorDropdownz1 = false;
      }     
    });
    
    $('.bold_option_element select').each( function(){
      if( $(this).val() == '' ){
        checkBoldDropdownz1 = false;
      }
    });
    
    if( checkColorDropdownz1 == true &&  checkBoldDropdownz1 == true ){
      $('.product-form--alt .shopify-payment-button').show();
    } else {
      $('.product-form--alt .shopify-payment-button').hide();
    }
  });
  // color dropdown check ends here.
  
  
  //On Bold dropdowns change
  var timer = setInterval(function(){
    if( $(".bold_option_element select").length > 0 ){
      
      $('.bold_option_element select').on('change', function(){
        var checkColorDropdownz2 = true;
  	  	var checkBoldDropdownz2 = true;
        
        $('.bold_option_element select').each( function(){
          if( $(this).val().length === 0 ){
            checkBoldDropdownz2 = false;
          }
        });
        
        $('.single-option-selector').each( function(){
          if( $(this).val().indexOf('Choose a') > -1 ){
            checkColorDropdownz2 = false;
          }
        });
        
        if( checkColorDropdownz2 == true &&  checkBoldDropdownz2 == true ){
          $('.product-form--alt .shopify-payment-button').show();
        } else {
          $('.product-form--alt .shopify-payment-button').hide();
        }
        
      });   
      
      clearInterval(timer);
    }
  }, 1);
  //Bold dropdowns check ends here.
  
  
  
  /*var checkBoldDropdownz = true;
  var timer = setInterval(function(){
    if( $(".bold_option_element select").length > 0 ){
      $('.bold_option_element select').on('change', function(){
        $('.bold_option_element select').each( function(){
          if( $(this).val() == '' ){
            checkBoldDropdownz = false;
          }
        });
      });
      clearInterval(timer);
    }
  }, 1);*/
  
  
});